import React, { useState, Fragment, useEffect } from 'react';
import {
  Card,
  CardBody,
  Button,
  ButtonGroup,
  Modal, ModalHeader,
  Form, Input,
  CustomInput,
  ModalFooter,
  
  FormGroup,
  Row, ModalBody
} from 'reactstrap';

import Fonts from '../../propinfo/fonts/index';
import { Colxx, Separator } from '../../../../../components/common/CustomBootstrap';
import Tooltip from './Tooltip';
import { uuid } from 'short-uuid';
import { postAPI_Vouchers_fonts } from '../../../../../constants/APIs';
import { Settings } from '@material-ui/icons';

let arr = [];
export default function StandAloneFonts({
  botSettings,
  integrationProperties,
  allProperties,
  saveIntegration,
}) {  

  const [formatedProperties, setFormatedProperties] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [list, setList] = useState([]);
  const [isOpen,setIsOpen]=useState(false);
  const [name, setName] = useState('');
  const [fontId, setFontId] = useState('0');
  const [galleryVisible, setGalleryVisible] = useState(false);

  const [customFonts, setCustomFonts] = useState([{
    id: uuid(),
    fontLink: '',
    fontName: '',
  }])

  useEffect(() => {
    if(botSettings.customFonts !==undefined && botSettings.customFonts.length>0)
    {
      let font=[];
      botSettings.customFonts.map((m)=>font.push({
        id: uuid(),
        fontLink: m.fontLink,
        fontName: m.fontName,
      }));
      setCustomFonts(font);
    }
  }, [integrationProperties, allProperties]);

  const handleCheckChange = e => {
    if (e.target.checked) {
      arr[e.target.id] = e.target.value;
    }
    if (!e.target.checked) {
      arr[e.target.id] = undefined;
    }
    const filterList = arr.filter(elem => elem !== undefined || null);
    setList(filterList);
  };
  const selectedImage = (image) => {    
    if(image[0].name.includes('woff'))
    {

    }else{
      setIsOpen(false);
    }

  };

  const AddFonts = () => {

    let fonts = [...customFonts];;
    fonts.push({
      id: uuid(),
      fontLink: '',
      fontName: '',
    });
    setCustomFonts(fonts);    
  };

  const RemoveFonts = (id) => {    
    let fonts = customFonts.filter(f => f.id !== id);
    setCustomFonts(fonts);
  };
 
  const handleSave = () => {
    let setting=botSettings;
    setting.customFonts = customFonts;        
    saveIntegration({ PageSettings:setting  
 });
      
    arr = [];
    setList([]);
    setIsEditing(!isEditing);
  };

  const handleNameChange = e => {
    setName(e.taget.value);
  };
  const handleSaveLink=(e,id)=>{
    let fonts=[...customFonts];
    
    if(fonts.filter(f=>f.id===id).length>0)
    {
      fonts.filter(f=>f.id===id)[0].fontLink=e.target.value;
    }    
    setCustomFonts(fonts);
  }
  const saveUploadLink=(e)=>{
    let fonts=[...customFonts];

    if(fonts.filter(f=>f.id===fontId).length>0)
    {
      fonts.filter(f=>f.id===fontId)[0].fontLink=e.status;
    }
  
    setCustomFonts(fonts);
  }
  const handleSaveName=(e,id)=>{

    let fonts=[...customFonts];    
    
    if(fonts.filter((f)=>f.id===id).length>0){
      fonts.filter((f)=>f.id===id)[0].fontName=e.target.value;
    }
    
    
    setCustomFonts(fonts);
  }
  const ImageGalleryButton = () => {
    return (
      <Row>
        <Colxx xs="12" sm="12" md="12" lg="12" className="mb-4">
          <Row>
            <Colxx xs="12" sm="3" className="mb-1">
              <Modal
                isOpen={galleryVisible}
                toggle={togglegallery}
                style={{ maxWidth: '1000px' }}
              >
                <ModalHeader toggle={togglegallery}>Upload Fonts</ModalHeader>
                <ModalBody>
                  <Fonts
                    uploadLink={(e)=>saveUploadLink(e.data)}
                    selectedImage={selectedImage}
                    togglegallery={togglegallery}
                    hideUserUploads={false}
                    searchText={'avatar'}
                  />
                </ModalBody>
              </Modal>
            </Colxx>
          </Row>
        </Colxx>
      </Row>
    );
  }; 
  const togglegallery = (id) => {
    
    setGalleryVisible(!galleryVisible);
    setFontId(id);
  };

  return (
  <Card className="mb-4"> 
    <CardBody>
      <div className="text-center">
        <h6>
          Upload Fonts
        </h6>
        <Separator className="mb-3" />        
        {customFonts.length >0 && customFonts.map((m) => {          
          return (
            <Fragment>
              <div className='mt-2'>
               <div>
                  <h6>Font Name</h6>
                  <div className="mb-2">
                    <Input
                      type="text"
                      value={m.fontName}
                      onChange={(e)=>handleSaveName(e,m.id)}
                      name="name"
                    />
                  </div>
                </div>
                <div >
                  <h6>Font Link</h6>
                  <div className="mb-2">
                    <Input
                      type="text"
                      value={m.fontLink}
                      onChange={(e)=>handleSaveLink(e,m.id)}
                      name="name"
                    />
                  </div>
                </div>

                <div className="mb-1 mt-4 ml-2">
                  <Button
                    color="success"
                    size="xs"
                    className="mt-1"
                    onClick={()=>togglegallery(m.id)}
                  >
                    Browse Fonts
                  </Button>
                  <Button
                    className="ml-1 mt-1"
                    style={{backGround:'red'}}
                    color="warning"
                    size="xs"
                    onClick={() => RemoveFonts(m.id)}
                  >
                    Remove Fonts
                  </Button>
                </div>
              </div>
            </Fragment>);
        })}
        <Button
          size="xs"
          color="success"
          outline
          style={{ marginTop: '20px', display: 'inline-block' }}
          onClick={AddFonts}
        >
          Add Fonts
        </Button>
        <Button
          size="xs"
          color="success"
          className="ml-2"
          outline
          style={{ marginTop: '20px', display: 'inline-block' }}
          onClick={() => handleSave()}
        >
          Save
        </Button>
      </div>
      {ImageGalleryButton()}
    </CardBody>
      <Modal isOpen={isOpen} toggle={() => setIsOpen(!isOpen)
      }>
        <ModalHeader toggle={() => setIsOpen(!isOpen)}>
          Custom Fonts
        </ModalHeader>
        <ModalBody>
          <p className="m-auto">
            Font file is not valid. Try again after some time.
          </p>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => { setIsOpen(!isOpen);}}>
            Close
          </Button>
        </ModalFooter>
      </Modal>      
  </Card>);
}
